export const PRODUCT_NEIGHBOR_LIST = 'WI99020070';
export const PRODUCT_NEIGHBOR_LIST_NEW = 'WI99020072';
export const PRODUCT_NEIGHBOR_LIST_PROD = 'WI25100100';
export const PRODUCT_NEIGHBOR_LIST_CADASTRE_INPUT = 'WI99020075';
export const PRODUCT_OWNER_LIST = 'WI25250110';
export const PRODUCT_OWNER_LIST_NEW = 'WI25250030';
export const PRODUCT_CADASTRE_REPORT = 'WE25401100';
export const PRODUCT_CADASTRE_REPORT_INFO = 'WE25401110';
export const PRODUCT_CADASTRE_REPORT_BUILDINGS = 'WE25401120';
export const PRODUCT_MULTIPLE_REPORT_CADASTRE = 'WE25403000';
export const PRODUCT_BROKER_LETTER_REPORT = 'WE25409999';

export const PRODUCTS_LAND_REGISTRY_LOOKUP = {
  WE25400100: 'TITLES',
  WE25400110: 'TITLES',
  WE25400200: 'MONETARY_ENCUMBRANCES',
  WE25400210: 'MONETARY_ENCUMBRANCES',
  WE25400400: 'EASEMENTS',
  WE25400410: 'EASEMENTS',
  WE25400500: 'LANDDATA',
  WE25400510: 'LANDDATA',
  WE25400600: 'PRIVILEGES',
  WE25400610: 'PRIVILEGES',
  WE25400700: 'ENCUMBRANCES',
  WE25400710: 'ENCUMBRANCES'
};

export const REPORTS = {
  WE25400100: 'Hjemmel',
  WE25400110: 'Hjemmel historikk',
  WE25400200: 'Pengeheftelser',
  WE25400210: 'Pengeheftelser historikk',
  WE25400400: 'Servitutter',
  WE25400410: 'Servitutter historikk',
  WE25400500: 'Grunndata',
  WE25400510: 'Grunndata historikk',
  WE25400600: 'Eiendommens rettigheter',
  WE25400610: 'Eiendommens rettigheter historikk',
  WE25400700: 'Heftelser',
  WE25400710: 'Heftelser historikk',
  WI99020070: 'Naboliste',
  WI99020072: 'Naboliste',
  WI99020075: 'Naboliste',
  WI25250030: 'Eierliste',
  WI25250110: 'Eierliste',
  WE25401100: 'Matrikkelrapport',
  WE25401110: 'Matrikkelopplysninger',
  WE25401120: 'Bygningsopplysninger',
  WE25403000: 'Rapport',
  WE25409999: 'Meglerbrev'
};

export const PRODUCTS_CADASTRE_REPORT = {
  WE25401100: 'ambita-cadastre-report-wrapper',
  WE25401110: 'ambita-cadastre-report-cadastre-info-wrapper',
  WE25401120: 'ambita-cadastre-report-buildings-wrapper'
};

export const API_ORDERS = '/shopping/v2/orders/';
export const API_SEARCH_CADASTRES = '/search/cadastres/';

export const TASK_NEIGHBOR_LIST = 'MAP_NEIGHBOR_LIST_TASK';
export const TASK_OWNER_LIST = 'MAP_OWNER_LIST_TASK';

export const MAIN_CADASTRE_BUFFER_METERS = 50;
export const SELECTION_BUFFER_METERS = 50;

export const FILTER_PROPERTY_NEIGHBOR_LIST = 'mainCadastre';
export const FILTER_PROPERTY_OWNER_LIST = 'isGeoSelection';
